import React,{useState,useEffect} from 'react'
import { Row, Col, Container } from "react-bootstrap"
import { makeStyles, useTheme,  withStyles, } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PaymentIcon from '@material-ui/icons/Payment';
import ReceiptIcon from '@material-ui/icons/Receipt';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import { InputGroup, InputGroupAddon, Input } from 'reactstrap';
import InputLabel from '@material-ui/core/InputLabel';
import {TextField, Select, FormGroup} from '@material-ui/core';
import { UncontrolledCollapse,Form, Collapse, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { ButtonToggle } from "reactstrap";
import {Accordion,Button,DropdownButton,ButtonGroup,Dropdown,Modal} from "react-bootstrap"
import { Link , Redirect} from 'react-router-dom';
import {toast , ToastContainer} from "react-toastify"
import { Tooltip } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'typeface-roboto';
import CreditCardInput from 'react-credit-card-input';
import "../App.css"
import Axios from 'axios';
import { base_url } from '../globalConstants';



const cancel={
    color:"darkblue",
    paddingRight: "27px",
    paddingLeft: "27px",
    paddingTop: "15px",
    paddingBottom: "17px",
    borderRadius:"25px",
    border:"none",
    float:"right",
    
  }

  const buttonstyle={
    color:"darkblue",
    backgroundColor:"skyblue",
    paddingRight: "27px",
    paddingLeft: "27px",
    paddingTop: "15px",
    paddingBottom: "17px",
    textAlign: "center",
    textDecoration: "none",
    borderRadius:"25px",
    border: "3px solid",
    float:"right",
    
  }


/*function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Card Authorization
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>Status</h4>
          {
            props.isCardUpdated
            ?<h5>Card Authorization Successfull</h5>
            :<h5>Card Update and Authorization Successfull</h5>
          }          
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>OK</Button>
        </Modal.Footer>
      </Modal>
    );
  }*/


export default function Referral() {
    const [modalShow, setModalShow] = React.useState(false);
   
    const [isOpen1, setIsOpen1] = useState(false);
  
   
    const toggle1 = () => setIsOpen1(!isOpen1);
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [tooltipOpenExpire, setTooltipOpenExpire] = useState(false);
    const [tooltipOpenCvv, setTooltipOpenCvv] = useState(false);
    const [tooltipOpenZipcode, setTooltipOpenZipcode] = useState(false);


    const [username,setusername]=useState('')
    const [validated,setValidated]=useState(false);
    const [EzzId,setEzzId]=useState('')

    const [CardNumber, setCardNumber]=useState(' ');
    const [ExpiryMonth,setExpiryMonth]=useState(' ');
    const [ExpiryYear ,setExpiryYear]=useState(' ');
    const [CVV ,setCVV]=useState(' ');
    const [monthList, setMonthList]=useState([])
    const [yearList, setYearList]=useState([])
    const [isCardAdded, setIsCardAdded]=useState(false)
    const [currCardNumber, setCurrCardNumber]=useState('')
    const [currCardType, setCurrCardType]=useState('')
    const [currCardExpiry, setCurrCardExpiry]=useState('')
    const [errorCard, setErrorCard] = useState('')
    const [isCardUpdated, setIsCardUpdated] = useState(false)
    const [isAddress, setIsAddress] = useState(false)
    
    const [NewPwd, setNewPwd]=useState(' ');
    const [FriendPhone,setFriendPhone]=useState(' ');
    const [ConfirmPwd ,setConfirmPwd]=useState(' ');
      const[Country,setCountry]=useState('');
      const [Details,setDetails]=useState([]);
      const [State,setState]=useState([]);
 const [TeleCode,setTeleCode]=useState('');
const [CountryCode,setCountryCode]=useState('');
const [PhoneLength,setPhoneLength]=useState('');
const [RefMsg,setRefMsg]=useState('');
const [Nation,setNation]=useState('')
const [errorMessage, setErrorMessage] = useState('')
const[Phone,setPhone]=useState('');
    // console.log("tempMonth",tempMonth);
  

  const toggle2 = () => setTooltipOpen(!tooltipOpen);
  const toggleexpire = () => setTooltipOpenExpire(!tooltipOpenExpire);
  const toggleCvv = () => setTooltipOpenCvv(!tooltipOpenCvv);
  const togglezipcode = () => setTooltipOpenZipcode(!tooltipOpenZipcode);


//   const handleChangePhone=(event)=>{
//    // console.log(event.length, 'length of event is');
//   //  setErrorNotVerified("")
//    setErrorMessage("")
//    setPhone(event.target.value);

// }


    // const fetchcountries=async e=>{
    //         const {data}=await Axios.get(base_url + 'country_state_details/')
    //         console.log(data)
    //         setDetails(data);
            
    //     }

  useEffect(()=>{

    setusername(localStorage.getItem('username'));
    setValidated(localStorage.getItem('validated'));
    setEzzId(localStorage.getItem('ezzyid'));
    // var temp_month = []
    // for(var i=1; i<=12; i++ )
    //   temp_month.push(i)
    // setMonthList(temp_month)

    // var temp_year = []
    // var curr_year = (new Date()).getFullYear()
    // for(var i=0; i<10; i++){
    //   var new_year = (curr_year+i).toString()
    //   // new_year = new_year.substring(2)
    //   temp_year.push(new_year)
    // }
      
      
    // console.log('temp_year',temp_year);  
    // setYearList(temp_year)
    // fetchcountries();
    
  
   },[])

//   const handleChangeCountry=(event)=>{
//   setCountry(event.target.value);
//   document.getElementById('Phone').value = ''

//     Details.map(keys=>{
      
//       if(keys.name===event.target.value){
//         setState(keys.states);
//        setCountryCode(keys.telecode);
//       setPhoneLength(keys.tele_length);
//        console.log(`Telecode Isss ${keys.telecode}`)
//        setNation(keys.country_id);
//        console.log(keys.country_id)
//         console.log(keys.states)
//         setTeleCode(keys.telecode);
//         console.log(keys.telecode)
//       }
//     })
//   }

    const handleFormSubmit=async (e)=>{
       e.preventDefault();
    
    console.log(NewPwd);
    console.log(EzzId);
   
    // console.log(FriendPhone);
    console.log(ConfirmPwd);
    // console.log(base_url);
    let token = localStorage.getItem("token")
    //console.log('TOKEN',token)
    let header = {
      'Content-Type': 'application/json',
      'AUTHORIZATION': token,
    }

    if (NewPwd != ConfirmPwd)
    {
        toast.error("Oh Snap! Something is Wrong.Please try again");
        return;
    }
    if (ConfirmPwd.length < 8)
    {
        toast.error("Password must be atleast 8 character long.");
        return;
    }
    
// ,headers: header
       Axios({
            method:'post',
            url:base_url+'update_customer/',
            data: {
            "password" : ConfirmPwd, 
            "ezzid" : EzzId
            },
            headers: {'Content-Type': 'application/json' }
          }).then(function(email){
            console.log(email);
            console.log('information updated successful');
            toast.info("Information updated successfully!");
          }).catch(function(email){
            console.log(email)
            console.log('updation failed')
            toast.error("Oh Snap! Something is Wrong.Please try again");
          })

        
         


   }

    return (
      <div>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={9}>
            <h3 style={{ marginLeft: '10px' }} id="paymentreminder">Change Password</h3>
          </Grid>

          <Grid item xs={3}>
            <h5 style={{ float: 'right' }}>Customer ID: {EzzId}</h5>
          </Grid>
        </Grid><br/>

        <Container>
          <Row>
            <Col>
            <Form>
            
            <Row>
              <Col  lg={{ span: 8 }} >
              <h5 style={{color:"grey"}}>Enter New Password</h5> 
                <InputGroup size="lg" >
                  <TextField type="password"  id="outlined-required" label="New Password" onChange={(e) => setNewPwd(e.target.value)}                   
                  placeholder="Enter New Password" variant="outlined" fullWidth required/>
                  {/* <Input placeholder="Enter your Card Number" onChange={(e) => setCardNumber(e.target.value)} type="number" style={{ borderRadius: "3px", borderColor: "#58585f" }} /> */}
                </InputGroup>
              </Col>
            </Row><br/>
            
            <Row>
              <Col  lg={{ span: 8 }} >
              <h5 style={{color:"grey"}}>Enter Confirm Password</h5> 
                <InputGroup size="lg" >
                  <TextField  type="password"  required id="outlined-required" label="Confirm Password" onChange={(e) => setConfirmPwd(e.target.value)}                   
                  placeholder="Enter Confirm Password" variant="outlined" fullWidth />
                  {/* <Input placeholder="Enter your Card Number" onChange={(e) => setCardNumber(e.target.value)} type="number" style={{ borderRadius: "3px", borderColor: "#58585f" }} /> */}
                </InputGroup>
              </Col>
            </Row><br/>

            <Row>
                                  
              <Col lg={{ span: 12 }} >
                <FormControl >
                                <p style={{color:'green', fontWeight: 'bold',  fontSize: 'large'}}> {RefMsg} </p>
                  </FormControl>
              </Col>
            </Row><br/>

            <Row>
              <Col  lg={{ span: 2, offset: 4 }}  >
                {/*<Button variant='outline-info' size='lg' block>Cancel</Button>                          */}
              </Col>  {' '}
              <Col lg={{ span: 2 }}  >
                <Button variant='info' onClick={(e)=>handleFormSubmit(e)} size='lg' block>Submit</Button>
                  
                
                
              </Col>
              {/*<MyVerticallyCenteredModal
                show={modalShow}
                onHide={() => setModalShow(false)} />          */}
            </Row>
          </Form>   
            </Col>
           
          </Row>

       
        </Container>

       <ToastContainer/>
        </div>
    )
}
